import {
  REFRESH_GROUP_BALANCES_START,
  REFRESH_GROUP_BALANCES_SUCCESS,
  REFRESH_GROUP_BALANCES_FAILED,
} from 'constants/action-types/groups/refreshGroupBalances';
import notification from 'helpers/notificationHelper';
import { ERROR } from 'constants/notificationStatus';
import apiAction from 'helpers/apiAction';

export default onComplete => dispatch => {
  dispatch(
    apiAction({
      url: '/admin/groups/refresh_balances',
      method: 'PUT',
      API_REQUEST_START: REFRESH_GROUP_BALANCES_START,
      API_REQUEST_SUCCESS: REFRESH_GROUP_BALANCES_SUCCESS,
      API_REQUEST_FAILURE: REFRESH_GROUP_BALANCES_FAILED,
      callbackOnSuccess: ({ message }) => {
        notification({ message });
      },
      callbackOnFailure: ({ message }) => {
        dispatch({
          type: REFRESH_GROUP_BALANCES_FAILED,
          payload: message,
        });
        notification({ message, status: ERROR });
      },
      onEnd: () => {
        if (onComplete) onComplete();
      },
    }),
  );
};
